import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { Order } from 'src/app/shared/interfaces/orders/order.interface'
import { OrderFilter } from 'src/app/shared/interfaces/orders/orders-filter.interface'
import { getPagedFilterParams } from '../../helpers/get-filters'
import { PaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-list.interface'
import { ApiResponsePaginatedList } from 'src/app/shared/interfaces/api-response/api-paginated-response.interface'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class OrdersService {
    #httpClient = inject(HttpClient)

    getOrdersPaged(filter: OrderFilter): Observable<PaginatedList<Order>> {
        const params = getPagedFilterParams(filter)
        return this.#httpClient
            .get<ApiResponsePaginatedList<Order>>(`${environment.baseUrl}orders`, { params })
            .pipe(map((response) => response.result))
    }
}
